$(document).on('ready turbolinks:load', function() {
  toastr.options = {
    "showDuration": "1000",
    "hideDuration": "1000",
    "timeOut": "1000",
    "extendedTimeOut": "1000",
  }

  const $window = $(window);
  const $header = $('.header');
  const headerScrolledClass = 'header--scrolled';
  const $mobileMenu = $('.mobile-menu');
  const mobileMenuOpenClass = 'mobile-menu--open';
  let windowScroll = $window.scrollTop();

  $window.on('scroll', event => {
    windowScroll = $window.scrollTop();
    const isScrolled = $header.hasClass(headerScrolledClass);

    if (windowScroll > 20 && !isScrolled) {
      $header.addClass(headerScrolledClass);
    } else if (windowScroll <= 20 && isScrolled) {
      $header.removeClass(headerScrolledClass)
    }
  });

  $mobileMenu.on('click', function () {
    $(this).toggleClass(mobileMenuOpenClass);
  });

  $('[data-toggle="tooltip"]').tooltip()

  flashMessages();

  // bug with jQuery, details: https://github.com/select2/select2/issues/5993#issuecomment-802819789
  $(document).on('select2:open', () => {
    let allFound = document.querySelectorAll('.select2-container--open .select2-search__field');
    allFound[allFound.length - 1].focus();
  });
})

export function flashMessages() {
  $('#flash_messages .alert').each(function() {
    toastr[$(this).data('alert-type')]($(this).html());
  });
}
